'use client';
import { jsx } from 'react/jsx-runtime';
import { useFloatingLabelTextInputElement } from '../../contexts/internal/floating-label/index.js';
import { useDeprecatedProps } from '../../hooks/use-deprecated-props.js';
import { useFormFieldProps } from '../form/form.context.js';
import { renderWithRef } from '../core/render-with-ref.js';
import { useId } from '../../hooks/use-id.js';
import { RenderComp } from '../core/render-comp.component.js';

function _define_property(e, r, t) {
    return r in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: true,
        configurable: true,
        writable: true
    }) : e[r] = t, e;
}
function _object_spread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {}, o = Object.keys(t);
        "function" == typeof Object.getOwnPropertySymbols && (o = o.concat(Object.getOwnPropertySymbols(t).filter(function(e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
        }))), o.forEach(function(r) {
            _define_property(e, r, t[r]);
        });
    }
    return e;
}
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        t.push.apply(t, o);
    }
    return t;
}
function _object_spread_props(e, r) {
    return r = null != r ? r : {}, Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : ownKeys(Object(r)).forEach(function(t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
    }), e;
}
const TextInput = renderWithRef('TextInput', null, (t, a)=>{
    useDeprecatedProps('TextInput', t, [
        {
            propName: 'size',
            instructions: 'Sizing is now handled automatically by standardMode/compactMode'
        }
    ]);
    let i = useId(t.id), s = useFloatingLabelTextInputElement(_object_spread_props(_object_spread({}, t), {
        id: i
    })), u = useFormFieldProps(s.id), d = _object_spread({}, s, u), { children: f, size: b = 'standard', skin: l = 'standard' } = t, { 'aria-invalid': m } = u, y = new Set([
        'swan-input'
    ]);
    return ('error' === l || m) && y.add('swan-input-skin-error'), 'standard' !== b && y.add(`swan-input-${b}`), jsx(RenderComp, {
        root: "input",
        classNames: y,
        forwardedRef: a,
        props: d,
        children: f
    });
});

export { TextInput };
